import type { Monaco } from '@monaco-editor/react';
import type { languages } from 'monaco-editor';

export const PROMPT_LANGUAGE_ID = 'prompt-template';

export const registerPromptLanguage = (monaco: Monaco) => {
    // Register language if not already registered
    if (!monaco.languages.getLanguages().some((lang: languages.ILanguageExtensionPoint) => lang.id === PROMPT_LANGUAGE_ID)) {
        monaco.languages.register({ id: PROMPT_LANGUAGE_ID });

        // Define tokenizer for template variables
        monaco.languages.setMonarchTokensProvider(PROMPT_LANGUAGE_ID, {
            tokenizer: {
                root: [
                    // Double curly braces: {{variable}}
                    [/\{\{/, 'delimiter.curly', '@doubleCurly'],
                    // Dollar sign curly braces: ${expression}
                    [/\$\{/, 'delimiter.curly', '@dollarCurly'],
                    // Single curly braces with letters: {placeholder}
                    [/\{[a-zA-Z_][a-zA-Z0-9_]*\}/, 'variable'],
                    // XML-style tags: <tag>
                    [/<\/?[a-zA-Z_][a-zA-Z0-9_-]*>/, 'tag'],
                    // Comments: # or //
                    [/#.*$/, 'comment'],
                    [/\/\/.*$/, 'comment'],
                ],
                doubleCurly: [
                    [/[^}]+/, 'variable.name'],
                    [/\}\}/, 'delimiter.curly', '@pop'],
                ],
                dollarCurly: [
                    [/[^}]+/, 'variable.name'],
                    [/\}/, 'delimiter.curly', '@pop'],
                ],
            },
        });

        // Define theme rules for light theme
        monaco.editor.defineTheme('prompt-light', {
            base: 'vs',
            inherit: true,
            rules: [
                { token: 'delimiter.curly', foreground: '0000FF', fontStyle: 'bold' },
                { token: 'variable', foreground: '008080' },
                { token: 'variable.name', foreground: '008080', fontStyle: 'bold' },
                { token: 'tag', foreground: '800080' },
                { token: 'comment', foreground: '008000', fontStyle: 'italic' },
            ],
            colors: {},
        });

        // Define theme rules for dark theme
        monaco.editor.defineTheme('prompt-dark', {
            base: 'vs-dark',
            inherit: true,
            rules: [
                { token: 'delimiter.curly', foreground: '569CD6', fontStyle: 'bold' },
                { token: 'variable', foreground: '4EC9B0' },
                { token: 'variable.name', foreground: '4EC9B0', fontStyle: 'bold' },
                { token: 'tag', foreground: 'C586C0' },
                { token: 'comment', foreground: '6A9955', fontStyle: 'italic' },
            ],
            colors: {},
        });
    }
};
